export default __webpack_public_path__ + "static/media/keyMessage.ca822a71.svg";